import { render, staticRenderFns } from "./ColumnAssignedBy.vue?vue&type=template&id=3dbc5ead&"
import script from "./ColumnAssignedBy.vue?vue&type=script&lang=ts&"
export * from "./ColumnAssignedBy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports